module.exports = __webpack_public_path__ + "img/positive_3.23389c95.png";